const developingTheNextgenLeadersInOurUniqueWay = [
  {
    type: "paragraph",
    text: "Entrepreneurship is in the very DNA of Comsense Technologies. There is nothing more satisfying than creating innovative ways to keep our customers as well as our people happy and ever-growing. We have always believed that Entrepreneurs are not just born but can be made through experiential learning in real-life situations.  If the employees are given a growth-conducive environment with all necessary resources, entrepreneurship will most definitely bloom, and your employees can become business leaders of tomorrow. In line with that thought and spirit, we have recently launched our in-house Entrepreneurship Development Program (EDP).",
  },
  {
    type: "paragraph",
    text: "EDP is a professional experiment designed by Comsense to provide experiential learning opportunities to a small select group of employees in the maiden batch, which will help them ramp up their skills for becoming an entrepreneur or for effectively performing Executive roles within the company. The Introductory batch includes 8 highly talented team members from our organization who will be trained on the job for various skill sets like sales and marketing, finance, team management, innovation management, and enabling diversity. Along with their day-to-day responsibilities of core job function, the chosen team will be encouraged to take ownership of new projects, develop their idea/business concept starting on paper, and moving it into the real world. They will lead teams, nurture their team members, and contribute towards establishing a growth-oriented team environment.",
  },

  {
    type: "heading",
    text: "Three Core Elements of Entrepreneurship Development Program Are:",
  },
  {
    type: "list",
    items: [
      "Developing Entrepreneurship as a Professional Experiment with Co-founders as Mentors",
      "Entrepreneurship skills training: Leadership, Idea generation & execution",
      "Untraditional Learning Path – an unusual way of teaching/learning new things by doing it yourself and with your team",
    ],
  },

  {
    type: "heading",
    text: "The Program is designed as a 24-month journey with Four key stages:",
  },

  {
    type: "heading",
    text: "Phase I: Discovery –",
  },
  {
    type: "paragraph",
    text: "Over this period, the participants will be introduced to entrepreneurship and its principles. They would work on a project of their choice along with our co-founders. This is an opportunity for them to take ownership of something they are passionate about and find out what turns into a business idea that meets market needs.",
  },

  {
    type: "heading",
    text: "Phase II: Ideation & Systems Thinking –",
  },
  {
    type: "paragraph",
    text: "Participants shall develop ideas from phase one and carry out customer validation using Start-up Principles & System thinking",
  },

  {
    type: "heading",
    text: "Phase III: Execution –",
  },
  {
    type: "paragraph",
    text: "The Entrepreneurship Program participants and the Comsense Management Team would work together to execute the chosen idea.",
  },

  {
    type: "heading",
    text: "Phase IV: Growth & Optimization –",
  },
  {
    type: "paragraph",
    text: "Entrepreneurship Development Program shall be scaled up depending on the success of this pilot project.",
  },

  {
    type: "paragraph",
    text: "The Program aims to provide a professionally safe space for the employees to explore themselves as leaders while also pushing their boundaries to achieve professional growth. We wish success to everyone involved in this.",
  },
];

export default developingTheNextgenLeadersInOurUniqueWay;
